import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import Animated, {
  useAnimatedReaction,
} from 'react-native-reanimated';

import { IconTouchable } from '../../common/IconTouchable';

export interface IVolumeIconTouchableProps {
  volume: Animated.SharedValue<number>;
  onToggleVolume(value: number): void;
}

export const VolumeIconTouchable =
  observer<IVolumeIconTouchableProps>(
    ({ volume, onToggleVolume }) => {
      const [iconName, setIconName] = useState('volume-up-bold');
      const [toggledVolume, setToggledVolume] = useState(0);

      useAnimatedReaction(
        () => volume.value,
        (result) => {
          if (result === 0) {
            setIconName('volume-off-bold');
          } else if (result < 0.5) {
            setIconName('volume-down-bold');
          } else {
            setIconName('volume-up-bold');
          }
        },
      );

      function toggleVolume() {
        if (volume.value > 0.1) {
          onToggleVolume(0);
          setToggledVolume(volume.value);
        } else {
          if (toggledVolume === 0) {
            onToggleVolume(1);
          } else {
            onToggleVolume(toggledVolume);
          }
        }
      }

      return (
        <IconTouchable
          name={iconName}
          color="$background0"
          onPress={toggleVolume}
        />
      );
    },
  );
